module.exports = __webpack_public_path__ + "static/media/icn_aadhaar_kyc_small.67cd8595.svg";